import { QPerson, QStack, QText, useCurrentUser } from '@qualio/ui-components';
import { Approver, FormStatusEnum } from '../../../../types';

type UserWithCommentProps = {
  approver: Approver;
  approvalType: 'approve' | 'review';
  formStatus: FormStatusEnum;
};

export const UserWithComment = ({ approver, approvalType, formStatus }: UserWithCommentProps) => {
  const { formatDate } = useCurrentUser();
  const has_comment = approver.approval_comment;
  const form_is_in_flight = [
    FormStatusEnum.For_Review,
    FormStatusEnum.For_Approval,
    FormStatusEnum.Approval_Declined,
  ].includes(formStatus);
  const form_is_completed = [
    FormStatusEnum.Approval_Declined,
    FormStatusEnum.Superseded,
    FormStatusEnum.Approved,
    FormStatusEnum.Cancelled,
  ].includes(formStatus);
  const status = () => {
    if (
      formStatus === FormStatusEnum.Draft ||
      (form_is_completed && approver.action_status === 'pending') ||
      (formStatus === FormStatusEnum.For_Review && approvalType === 'approve') ||
      (formStatus === FormStatusEnum.For_Approval && approvalType === 'review' && approver.action_status === 'pending')
    ) {
      return 'default';
    }
    if (approvalType === 'review' && approver.action_status === 'approved') {
      return 'reviewed';
    }
    return approver.action_status;
  };

  return (
    <QStack key={approver.id} spacing={1}>
      <QPerson
        key={`${approver.id}-${approver.action_status}`}
        status={status()}
        fullName={approver.full_name}
        actionTimestamp={
          approver.action_timestamp ? formatDate(new Date(approver.action_timestamp * 1000), true) : undefined
        }
      />
      {has_comment && form_is_in_flight && (
        <QText as="i" fontSize="xs" mt={1} color="gray.700">
          {approver.approval_comment}
        </QText>
      )}
    </QStack>
  );
};
